var _circle, _path, _path2, _g, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGiftCardinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#E4E9F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 34c0 18.778-15.222 34-34 34S0 52.778 0 34 15.222 0 34 0s34 15.222 34 34z",
    fill: "#E4E9F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.468 9.459C16.577 3.6 24.868 0 34 0c18.778 0 34 15.222 34 34 0 9.01-3.504 17.2-9.224 23.284L10.468 9.459z",
    fill: "#798FD6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#gift-card_inline_svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.133,
    y: 18.133,
    width: 31.733,
    height: 31.733,
    rx: 4,
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6 26H24.4a1.6 1.6 0 00-1.6 1.6v12.8a1.6 1.6 0 001.6 1.6h19.2a1.6 1.6 0 001.6-1.6V27.6a1.6 1.6 0 00-1.6-1.6z",
    fill: "#6B7696"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41 29h-6a1 1 0 00-1 1v2a1 1 0 001 1h6a1 1 0 001-1v-2a1 1 0 00-1-1z",
    fill: "#363C4C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "gift-card_inline_svg__filter0_d",
    x: 10.133,
    y: 18.133,
    width: 47.733,
    height: 47.733,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    "in": "SourceAlpha",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.172965 0 0 0 0 0.162254 0 0 0 0 0.366665 0 0 0 0.49867 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

export default SvgGiftCardinline;